import {
    Box,
    Grid,
    Stack, Typography
} from '@mui/material';
import React, {ReactNode} from "react";
import {Logo} from "../index";
import dayjs from "dayjs";

interface Props {
    children: ReactNode;
}

const PdfLetterHead: React.FC<Props> = ({children}) => {
    return (
        <Box sx={{width: '100%',p:2 }}>
            <Grid container
                  direction={'column'}
                  justifyContent={'space-between'}
            >
                <Grid item>
                    <Logo />
                </Grid>
                <Grid item>
                    <Typography fontSize={12} ml={2} color={'text.secondary'}>
                        Report generated at : {dayjs().format('MM/DD/YYYY hh:mm A')}
                    </Typography>
                </Grid>
            </Grid>
            <Stack mt={4} p={2}>
                {children}
            </Stack>
        </Box>
    );
}

export default PdfLetterHead;